import { Group, Tooltip, type TooltipProps } from "@mantine/core";
import type { TablerIcon } from "@tabler/icons-react";
import { MantineCellIcon } from "./MantineCellIcon/MantineCellIcon";

interface MantineIconCellProps {
  IconComponent: TablerIcon;
  iconColor?: string;
  renderedCellValue: React.ReactNode;
  tooltipLabel?: TooltipProps["label"];
}

function MantineIconCell({
  IconComponent,
  iconColor,
  renderedCellValue,
  tooltipLabel
}: MantineIconCellProps) {
  if (typeof renderedCellValue === "string" && !renderedCellValue) {
    return null;
  }

  return (
    <Group className="MantineIconCell" gap="sm" wrap="nowrap">
      {tooltipLabel ? (
        <Tooltip label={tooltipLabel}>
          <MantineCellIcon
            iconColor={iconColor}
            IconComponent={IconComponent}
          />
        </Tooltip>
      ) : (
        <MantineCellIcon iconColor={iconColor} IconComponent={IconComponent} />
      )}
      {renderedCellValue}
    </Group>
  );
}

export { MantineIconCell, MantineIconCellProps };
